import { render } from "./UiErrors.vue?vue&type=template&id=64c151bc"
import script from "./UiErrors.vue?vue&type=script&lang=js"
export * from "./UiErrors.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__